import { bffServiceClient } from 'packages/request/clients';
import { getResult } from 'helpers/request';
import { IGetLocationFromAddressParams } from 'interfaces/shop';

const getLocationFromAddress = (
  params: IGetLocationFromAddressParams
): Promise<{ lat: number; lng: number }> => {
  return bffServiceClient.get('/common/googleMap', { params }).then(getResult);
};

export default { getLocationFromAddress };
